// extracted by mini-css-extract-plugin
export var newsletter = "newsletterform-module--newsletter--aace1";